import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';

import { App } from './App';
import { theme } from './theme';
import { GlobalStyle } from './theme/GlobalStyle';

import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <App />
  </ThemeProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
